import Model from '../Model'
import moment from "moment";
export default class ToolboxTalk extends Model {

    getDownloadUrl() {
        return route('api.v2.external.ppe-register.pdf', [this.id])+'?jwt='+((window.auth && window.auth.token)?window.auth.token:'')
    }

    getPrintableUrl() {
        return route('api.v2.external.ppe-register.download', [this.id])+'?jwt='+((window.auth && window.auth.token)?window.auth.token:'')
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            this.givenByName,
            this.formattedDate,
        ]
        this.tokens = tokens.join('|').toLowerCase();
        if (this.attendees) {
            this.attendees.sort((a, b) => a.order - b.order)
        }
    }

    static async find(id) {
        const data = await Http.get(route('api.v2.external.ppe-register', id)+ '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : ''))
        return this.make(data);
    }

}
